// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_HBS","cls2":"ExportFormatModal-cls2_lWX ExportFormatModal-cls1_HBS"};